import { useEffect, useState, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import api from '../api'; // Asegurate de tener configurado Axios o tu cliente API

const Multimedia = ({sala, setToast}) => {
  const [videos, setVideos] = useState([]);
  const [videoFile, setVideoFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [loadingToggle, setLoadingToggle] = useState(null);
  const salaId = sala?.id;
  const userRole = localStorage.getItem('role');
  const fileInputRef = useRef(null);

  const fetchVideos = async () => {
    if (!sala?.id) return;
    try {
      const res = await api.get(`/videos?sala_id=${sala.id}`);
      setVideos(res.data.videos);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, [sala]);

  const handleUpload = async () => {
    if (!videoFile) return;
    setIsUploading(true);

    const formData = new FormData();
    formData.append('video', videoFile);
    formData.append('sala_id', salaId); // muy importante

    try {
      await api.post('/videos/upload', formData);
      setToast({ show: true, variant: 'success', message: `Video cargado correctamente` });
      await fetchVideos();
      fileInputRef.current.value = '';
    } catch (err) {
      console.error(err);
      setToast({ show: true, variant: 'danger', message: 'Error al cargar el video' });
    } finally {
      setIsUploading(false);
    }
  };

  const handleDeleteVideo = async (row) => {
    const result = await Swal.fire({
      title: '¿Eliminar video?',
      html: `<b>${row.nombre}</b> será eliminado permanentemente.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    // Mostrar alerta de carga
    Swal.fire({
      title: 'Eliminando...',
      text: 'Por favor espera un momento',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      await api.delete('/videos/delete', {
        data: {
          sala_id: salaId,
          archivo: row.archivo,
        },
      });

      // Cerrar el spinner apenas termine
      Swal.close();

      setToast({ show: true, variant: 'success', message: 'Video eliminado correctamente' });
      await fetchVideos();
    } catch (err) {
      console.error(err);
      // Cerrar el spinner apenas termine
      Swal.close();
      setToast({ show: true, variant: 'danger', message: 'Error al eliminar el video' });
    }
  }

  const handleToggleEstado = async (row) => {
    setLoadingToggle(row.archivo);

    try {
      await api.post('/videos/toggle', {
        sala_id: sala.id,
        archivo: row.archivo,
        estado: row.estado === 'activo' ? 'inactivo' : 'activo',
      });
      setToast({ show: true, variant: 'success', message: 'Estado actualizado' });
      await fetchVideos();
    } catch (err) {
      console.error(err);
      setToast({ show: true, variant: 'danger', message: 'Error al actualizar el estado' });
    } finally {
      setLoadingToggle(null);
    }
  };

  const columns = [
      { name: 'Nombre', selector: row => row.nombre, sortable: true},
      { name: 'Estado', 
        selector: row => row.estado,
        cell: row => (
          loadingToggle === row.archivo ? (
            <div className="spinner-border spinner-border-sm text-primary" role="status" />
          ) : (
            <Form.Check
            type="switch"
            id={`switch-${row.archivo}`}
            checked={row.estado === 'activo'}
            onChange={() => handleToggleEstado(row)}
          />
          )
        ),
        ignoreRowClick: true,
        button: true,
      },
      {
        name: 'Opciones',
        cell: row => (
          <div className="d-flex gap-2">
            {userRole !== 'consulta' && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => handleDeleteVideo(row)} 
              >
                <Trash />
              </Button>
            )}
          </div>
        ),
     
      },
    ];

  return (
    <>
      <div>
        <Form.Group className="d-flex align-items-end gap-2">
          <div style={{ flex: 1 }}>
            <Form.Label>El tamaño máximo permitido por video es de 10 MB. Usa formato .mp4. Calidad 720 HD</Form.Label>
              <Form.Control
                type="file"
                accept="video/mp4"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const maxSize = 10 * 1024 * 1024; // 10 MB en bytes
                    if (file.size > maxSize) {
                      setToast({
                        show: true,
                        variant: 'warning',
                        message: 'El video no puede superar los 10 MB.'
                      });
                      e.target.value = ''; // limpia el input
                      return;
                    }
                    setVideoFile(file);
                  }
                }}
                ref={fileInputRef}
              />
          </div>
          <Button onClick={handleUpload} disabled={isUploading}>
            {isUploading ? 'Subiendo...' : 'Subir'} 
          </Button>
        </Form.Group>
      </div>
      <div style={{paddingTop: '20px'}}>
        <DataTable
          columns={columns}
          data={videos}
          pagination
          highlightOnHover
          responsive
          striped
        />
      </div>
    </>
  );
};

export default Multimedia;